import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e375eb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "kt_drawer_chat",
  class: "bg-white",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "chat",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'300px', 'md': '500px'}",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_chat_toggle",
  "data-kt-drawer-close": "#kt_drawer_chat_close",
  style: {"overflow-y":"hidden","z-index":"1600"}
}
const _hoisted_2 = {
  class: "card w-100",
  id: "kt_drawer_chat_messenger"
}
const _hoisted_3 = {
  class: "card-header pe-5 position-sticky",
  id: "kt_drawer_chat_messenger_header"
}
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "d-flex justify-content-center flex-column me-3" }
const _hoisted_6 = {
  href: "#",
  class: "fs-4 fw-bolder text-gray-900 text-hover-primary me-1 mb-2 lh-1"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-0 lh-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-7 fw-bold text-gray-400" })
], -1))
const _hoisted_8 = { class: "card-toolbar" }
const _hoisted_9 = { class: "me-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left-short" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right-short" }, null, -1))
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"btn btn-sm btn-icon btn-active-icon-primary\" id=\"kt_drawer_chat_close\" data-v-5e375eb2><span class=\"svg-icon svg-icon-1\" data-v-5e375eb2><i class=\"fs-3 el-icon el-dialog__close\" data-v-5e375eb2><svg viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" data-v-5e375eb2><path fill=\"currentColor\" d=\"M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z\" data-v-5e375eb2></path></svg></i></span></div>", 1)
const _hoisted_13 = {
  class: "card-body",
  id: "kt_drawer_chat_messenger_body"
}
const _hoisted_14 = {
  class: "scroll-y me-n5 pe-5 pb-10",
  ref: "messagesRef",
  "data-kt-element": "messages",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-dependencies": "#kt_drawer_chat_messenger_header, #kt_drawer_chat_messenger_footer",
  "data-kt-scroll-wrappers": "#kt_drawer_chat_messenger_body",
  "data-kt-scroll-offset": "0px",
  id: "kt-data-messages-scroll"
}
const _hoisted_15 = {
  key: 0,
  class: "fs-6 text-center mt-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_MessageIn = _resolveComponent("MessageIn")!
  const _component_MessageOut = _resolveComponent("MessageOut")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.title), 1),
            _hoisted_7
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Button, {
              class: "p-button-rounded margin-right-5",
              disabled: 
                _ctx.currentConversationIndex == 0 || _ctx.conversations?.length < 1
              ,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.previousConversation()))
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_Button, {
              class: "p-button-rounded",
              disabled: 
                _ctx.currentConversationIndex == _ctx.conversations?.length - 1 ||
                _ctx.conversations?.length < 1
              ,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.nextConversation()))
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _hoisted_12
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.uuid || index
            }, [
              (!item.own)
                ? (_openBlock(), _createBlock(_component_MessageIn, {
                    key: 0,
                    ref_for: true,
                    ref: "messagesInRef",
                    name: item.username,
                    image: item.image,
                    time: item.time,
                    text: item.text,
                    status: item.status
                  }, null, 8, ["name", "image", "time", "text", "status"]))
                : _createCommentVNode("", true),
              (item.own)
                ? (_openBlock(), _createBlock(_component_MessageOut, {
                    key: 1,
                    ref_for: true,
                    ref: "messagesOutRef",
                    image: item.image,
                    time: item.time,
                    text: item.text,
                    status: item.status
                  }, null, 8, ["image", "time", "text", "status"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          (_ctx.conversations?.length < 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, " No conversation available "))
            : _createCommentVNode("", true)
        ], 512)
      ]),
      (_ctx.currentConversationIndex != -1)
        ? (_openBlock(), _createBlock(_component_Footer, {
            key: 0,
            conversationId: _ctx.conversations[_ctx.currentConversationIndex]?.webId,
            isActiveConversation: true,
            onSendMessage: _ctx.scrollBottom
          }, null, 8, ["conversationId", "onSendMessage"]))
        : _createCommentVNode("", true)
    ])
  ]))
}